var _path, _path2, _path3, _ellipse, _path4, _path5, _ellipse2, _path6, _path7, _ellipse3, _path8, _path9, _path10, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotoSkateboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#82aec0",
    strokeMiterlimit: 10,
    strokeWidth: 8,
    d: "M111.66 75L83.92 59.74m-27.85 43.63L29.56 88.34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M43.3 94.91c2.97-4.49 7.69-5.74 11.31-4.2c5.54 2.35 6.41 4.3 6.41 4.3c-1.48 2.24-10.91 15.79-10.91 15.79s-3.93-1.74-6.26-3.84c-2.91-2.63-3.52-7.56-.55-12.05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#c62828",
    d: "M42.14 97.08s-.42 2.63 1.39 3.51c2.94 1.43 4.55-1.43 4.55-1.43s2.19-3.51 6.11-4.92c5.51-1.99 7.53 1.81 7.53 1.81s-1.46-4.53-7.96-5.63c-1.83-.31-5.83 1-7.04 1.7c-3.9 2.25-4.58 4.96-4.58 4.96"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.56,
    cy: 102.19,
    fill: "#ff7555",
    rx: 9.75,
    ry: 7.12,
    transform: "rotate(-56.515 54.565 102.191)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#c62828",
    d: "M53.1 103.95c.79-1.02 1.43-1.72 2.16-.7c.31.49.61 1.22 1.21 1.34c1.82.38 2.38-2.08 2.21-3.34c-.44-2.98-4.01-2.67-5.63-.07c-.94 1.42-.84 3.26-.47 4.12c0 .01.36-1.11.52-1.35"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M17.39 82.77c2.97-4.49 7.69-5.74 11.31-4.2c5.54 2.35 6.41 4.3 6.41 4.3c-1.48 2.24-10.91 15.79-10.91 15.79s-3.93-1.74-6.26-3.84c-2.91-2.63-3.52-7.56-.55-12.05"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.66,
    cy: 90.05,
    fill: "#c62828",
    rx: 9.75,
    ry: 7.12,
    transform: "rotate(-56.515 28.66 90.053)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M100.42 66.75c2.98-4.48 7.71-5.71 11.33-4.16c5.53 2.37 6.4 4.33 6.4 4.33c-1.49 2.24-10.96 15.75-10.96 15.75s-3.93-1.75-6.25-3.86c-2.91-2.65-3.5-7.58-.52-12.06"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#c62828",
    d: "M99.26 68.92s-.43 2.63 1.38 3.51c2.94 1.44 4.56-1.42 4.56-1.42s2.5-3.86 6.47-5.15c5.07-1.65 7.19 2.08 7.19 2.08s-1.48-3.74-7.57-5.4c-3.84-1.05-7.35.81-8.32 1.59c-3.54 2.81-3.71 4.79-3.71 4.79"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.66,
    cy: 74.06,
    fill: "#ff7555",
    rx: 9.75,
    ry: 7.12,
    transform: "rotate(-56.324 111.653 74.06)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#c62828",
    d: "M110.21 76.02c.53-.61 1.33-1.63 2.06-.6c.31.49.69.98 1.29 1.06c1.89.26 2.39-2.07 2.22-3.34c-.43-2.98-4-2.68-5.63-.09c-.94 1.41-.85 3.2-.49 4.12c0 0 .21-.75.55-1.15"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ddb98c",
    d: "M124.01 39.89c-3.52-10.2-9.89-11.48-12.39-12.37c0 0 4.48 3.82 6.53 8.46c2.64 6 2.49 13.52-3.24 17.58l-75.44 35.3C21.89 93.17 3.28 75.53 3.28 75.53c-.61 4.05-2.06 11.58 12.93 17.16c13.47 5.01 26.84 3.89 32.53 1.04l68.21-32.59c6.74-3.85 9.94-12.92 7.06-21.25"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M121.49 36.46c-3.52-10.2-15.25-10.61-21.92-8.92c-5.54 1.41-11.8 6.57-16.41 10.44c-2.48 2.08-6.4 3.87-6.4 3.87L20.18 68.92s-1.64.69-4.4.76c-2.82.07-10.92-.36-12.24 4.46c-1.18 4.33.65 10.08 13.79 15.04c13.45 5.08 23.2 3.97 28.9 1.13l68.21-32.59c6.73-3.85 9.93-12.92 7.05-21.26"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.37,
    cy: 81.35,
    fill: "#757575",
    rx: 2,
    ry: 2.68,
    transform: "rotate(-83.586 37.38 81.352)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.11,
    cy: 75.82,
    fill: "#757575",
    rx: 2,
    ry: 2.68,
    transform: "rotate(-83.586 28.11 75.823)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.86,
    cy: 76.9,
    fill: "#757575",
    rx: 2,
    ry: 2.68,
    transform: "rotate(-83.586 46.862 76.903)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.59,
    cy: 71.37,
    fill: "#757575",
    rx: 2,
    ry: 2.68,
    transform: "rotate(-83.586 37.592 71.374)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.81,
    cy: 56.25,
    fill: "#757575",
    rx: 2,
    ry: 2.68,
    transform: "rotate(-83.586 88.82 56.247)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.54,
    cy: 50.72,
    fill: "#757575",
    rx: 2,
    ry: 2.68,
    transform: "rotate(-83.586 79.55 50.718)"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.45,
    cy: 51.88,
    fill: "#757575",
    rx: 2,
    ry: 2.68,
    transform: "rotate(-83.586 98.458 51.879)"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.18,
    cy: 46.35,
    fill: "#757575",
    rx: 2,
    ry: 2.68,
    transform: "rotate(-83.586 89.188 46.35)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotoSkateboard);
export default __webpack_public_path__ + "static/media/noto--skateboard.380c664a1e3c62471e0a752a34b4b4c7.svg";
export { ForwardRef as ReactComponent };